import { gql } from '__generated__';

export default gql(`
  mutation ActivateDiscount($id: ID!) {
    activateDiscount(id: $id) {
      id
      active
    }
  }
`);
